import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";

import ReviewCard from "./ReviewCard";

const dummyReviews = [
  {
    profilePicture: null,
    userName: "Daniel K.",
    companyName: "Ugandan Landlord in Diaspora",
    starRating: 5,
    description:
      "I live in the UK and used to rely on relatives to collect rent in Kampala, which was stressful. With Tenafix, tenants pay straight through Mobile Money and I see the updates instantly. All my documents are stored online too, so I don’t have to deal with papers being lost back home.",
  },
  {
    profilePicture: null,
    userName: "Grace N.",
    companyName: "Landlord in Kampala",
    starRating: 4,
    description:
      "Tenafix makes it so easy to track my rentals. I just log in and see reports on who has paid, who’s late, and how my monthly income looks. The automated reminders have reduced delays — tenants now pay on time without me chasing them.",
  },
  {
    profilePicture: null,
    userName: "Samuel O.",
    companyName: "Property Manager",
    starRating: 5,
    description:
      "Before Tenafix, I had files all over my desk and receipts going missing. Now everything is digital — from tenancy agreements to rent records. I manage several buildings and finally have everything in one place, which makes my work so much easier.",
  },
  {
    profilePicture: null,
    userName: "James T.",
    companyName: "Apartment Owner",
    starRating: 4.5,
    description:
      "Even though I only own a few rental units, Tenafix makes me feel like I’m running a proper business. All my records are paperless, payouts are instant, and I can even raise tickets when I need help with maintenance or tax. It’s exactly the kind of support landlords like me need.",
  },
];

const ReviewCardSection = () => {
  return (
    <Swiper
      slidesPerView={1}
      slidesPerGroup={1}
      spaceBetween={0}
      loop={true}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
        reverseDirection: false, // or use a setInterval logic to reverse
      }}
      pagination={{ clickable: true }}
      modules={[Autoplay, Pagination]}
      className="w-full pb-12 "
      breakpoints={{
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 20,
        },
      }}
    >
      {dummyReviews.map((review, i) => (
        <SwiperSlide key={i}>
          <ReviewCard {...review} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default ReviewCardSection;
